export default "__VITE_ASSET__DFTb56O7__"